module.exports = __webpack_public_path__ + "img/resource.1518b14.png";